import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";

export interface SubscriptionStatus {
  currentPeriodEnd: number | null;
  cancelAtPeriodEnd: boolean;
  paymentProblem: boolean;
}

export const SUBSCRIPTION_STATUS_REFRESH_MS = 3 * 60 * 1000;

export function useSubscriptionStatus(poll = false, options: { refreshOnReturn?: boolean } = {}) {
  const { user } = useAuth();
  const isPaid = !!user && ["Paid", "Annual", "SearchAndBid"].includes(user.membershipTier || "");

  return useQuery<SubscriptionStatus>({
    queryKey: ["/api/stripe/subscription-status"],
    enabled: isPaid,
    staleTime: options.refreshOnReturn ? 0 : SUBSCRIPTION_STATUS_REFRESH_MS,
    refetchOnMount: options.refreshOnReturn ? "always" : true,
    refetchOnWindowFocus: true,
    // Only the layout banner polls; page badges share its cached response.
    refetchInterval: poll ? SUBSCRIPTION_STATUS_REFRESH_MS : false,
    refetchIntervalInBackground: false,
  });
}
